// @ts-strict-ignore
import React, { memo } from 'react'

import { useProductFlags } from '@/screens/Product/hooks/use-product-flags'
import { useProduct } from '@/screens/Product/hooks/useProduct'

import { BonusConversionWidget } from '@/widgets/bonus-conversion-widget'
import { DolyameWidget } from '@/widgets/dolyame-widget'

import { ProductServices } from '@/features/product-services/ui/ProductServices'
import { YandexPayWidget, YaPaySplitFastButton } from '@/features/YaSplit'

import { OrderType } from '@/shared/types/product-types'
import { Col, Row } from '@/shared/ui/Grid'

import { useProductPageData } from '../../../../hooks/use-product-page-data'

import { AuthTriggerBlock } from './components/auth-trigger-block'
import { CreditPanel } from './components/credit-panel/CreditPanel'
import { FoundLowerPriceBlock } from './components/found-lower-price-block/FoundLowerPriceBlock'
import { ProductDelivery } from './components/product-delivery/ProductDelivery'
import { ProductPageFixedPanel } from './components/product-page-fixed-panel/ProductPageFixedPanel'
import { ProductParameters } from './components/product-parameters/ProductParameters'
import { ProductPriceBlock } from './components/product-price-block/ProductPriceBlock'

import cl from './product-panel.module.scss'

export const ProductPanel = memo((): JSX.Element => {
	const { product } = useProduct()

	const { services } = useProductPageData(product.ID)

	const {
		isArchive,
		isProductBuy,
		isShowYandexSplitWidget,
		isIphone,
		isPriceUnderLimit,
		showAuthTrigger,
		showCreditPanel,
		productIsInStock,
		showSplit,
		SHOW_DOLYAME,
		isInStock
	} = useProductFlags()

	const { PRICE, ID } = product

	const showFixedPanel = productIsInStock || product.ORDER_TYPE === OrderType.Reservation

	return (
		<section id="productPanel" className={cl.productPanel}>
			<Row gutter={[24, 40]}>
				<Col xs={24} lg={12}>
					<ProductParameters />
				</Col>

				<Col xs={24} lg={12}>
					{showAuthTrigger && <AuthTriggerBlock />}

					{!isArchive ? (
						<section className={cl.section__withoutPadding}>
							<ProductPriceBlock />
						</section>
					) : (
						<div className={cl.emptyButton} />
					)}

					{isInStock && productIsInStock && isIphone && (
						<section className={cl.section}>
							<FoundLowerPriceBlock />
						</section>
					)}

					<BonusConversionWidget />

					<div id="PopMechanicAfterPriceBlock" />

					{showCreditPanel && isInStock && productIsInStock && (
						<section className={cl.section}>
							<CreditPanel ID={ID} price={PRICE.VALUE} />
						</section>
					)}

					{isInStock && SHOW_DOLYAME && <DolyameWidget />}

					{isInStock && productIsInStock && (
						<>
							<section className={cl.section__litleMargin}>
								{showSplit && isShowYandexSplitWidget && isPriceUnderLimit && (
									<div className={cl.yaPay}>
										<YandexPayWidget id={product.ID} price={product.PRICE.VALUE} />
									</div>
								)}
							</section>

							{showSplit && isShowYandexSplitWidget && (
								<div className={cl.yaPayButton}>
									<YaPaySplitFastButton id={product.ID} />
								</div>
							)}

							{!!product.DELIVERY && (
								<section className={cl.section__bottom_margin}>
									<ProductDelivery ORDER_TYPE={product.ORDER_TYPE} DELIVERY={product.DELIVERY} />
								</section>
							)}
						</>
					)}

					{isInStock && isProductBuy && <ProductServices viewType="info" services={services} relatedId={product.ID} />}
				</Col>
			</Row>

			{showFixedPanel && <ProductPageFixedPanel />}
		</section>
	)
})
